import { render, staticRenderFns } from "./perinformation.vue?vue&type=template&id=5bbfe9bd&scoped=true&"
import script from "./perinformation.vue?vue&type=script&lang=js&"
export * from "./perinformation.vue?vue&type=script&lang=js&"
import style0 from "./perinformation.vue?vue&type=style&index=0&id=5bbfe9bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbfe9bd",
  null
  
)

export default component.exports